__turbopack_context__.v({
  "content": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__content",
  "header": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__header",
  "logout": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__logout",
  "profile": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__profile",
  "root": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__root",
  "separator": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__separator",
  "text": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__text",
  "trigger": "landing-mobile-menu-sheet-module-scss-module__7ZqaMG__trigger",
});
